import React from 'react';
import UIComponent from './ui_component.js';
import { withStyles } from 'material-ui/styles';
import SendIcon from 'material-ui-icons/Send';
import ReplyIcon from 'material-ui-icons/Reply';
import ReplyAllIcon from 'material-ui-icons/ReplyAll';
import ForwardIcon from 'material-ui-icons/Forward';
import DraftsIcon from 'material-ui-icons/Drafts';
import CancelIcon from 'material-ui-icons/Cancel';
import AttachFileIcon from 'material-ui-icons/AttachFile';
import ArchiveIcon from 'material-ui-icons/Archive';
import DeleteIcon from 'material-ui-icons/Delete';
import SpamIcon from 'material-ui-icons/BugReport';
import DebugIcon from 'material-ui-icons/BugReport';
import ContactsIcon from 'material-ui-icons/Contacts';
import DoneIcon from 'material-ui-icons/Done';
import HomeIcon from 'material-ui-icons/Home';
import SearchIcon from 'material-ui-icons/Search';
import NotificationIcon from 'material-ui-icons/Notifications';
import MessageIcon from 'material-ui-icons/Email';
import FavoriteIcon from 'material-ui-icons/Favorite';
import ChatIcon from 'material-ui-icons/ChatBubble';
import RetweetIcon from 'material-ui-icons/Cached';
import EditIcon from 'material-ui-icons/Edit';
import CloseIcon from 'material-ui-icons/Close';
import NotFoundIcon from 'material-ui-icons/Block';
import DrawerIcon from 'material-ui-icons/Menu';
import BlogIcon from 'material-ui-icons/InsertComment';
import HistoryIcon from 'material-ui-icons/History';
import SettingsIcon from 'material-ui-icons/Settings';
import SaveIcon from 'material-ui-icons/Save';
import MenuIcon from 'material-ui-icons/MoreVert';
import QuestionIcon from 'material-ui-icons/Help';
import OKIcon from 'material-ui-icons/Done';

const styles = [];

class UIIcon extends UIComponent {
  constructor() {
    super();
    this.state = {
    }
  }

  getDefaults(){
    const defaults = {
      className: '',
    }    
    return defaults;
  }
  
  getIcon(icon){
    if(!icon) return null;

    switch(icon){
      case "send":
        return <SendIcon className={this.state.className}/>;
      case "reply":
        return <ReplyIcon className={this.state.className}/>;
      case "reply_all":
        return <ReplyAllIcon className={this.state.className}/>;
      case "forward":
        return <ForwardIcon className={this.state.className}/>;
      case "draft":
        return <DraftsIcon className={this.state.className}/>;
      case "cancel":
        return <CancelIcon className={this.state.className}/>;
      case "attach":
        return <AttachFileIcon className={this.state.className}/>;
      case "delete":
        return <DeleteIcon className={this.state.className}/>;
      case "archive":
        return <ArchiveIcon className={this.state.className}/>;
      case "spam":
        return <SpamIcon className={this.state.className}/>;       
      case "contacts":
        return <ContactsIcon className={this.state.className}/>;       
      case "done":
        return <DoneIcon className={this.state.className}/>;       
      case "home":
        return <HomeIcon className={this.state.className}/>;       
      case "search":
        return <SearchIcon className={this.state.className}/>;       
      case "notification":
        return <NotificationIcon className={this.state.className}/>;       
      case "message":
        return <MessageIcon className={this.state.className}/>;       
      case "favorite":
        return <FavoriteIcon className={this.state.className}/>;       
      case "reply-tweet":
        return <ChatIcon className={this.state.className}/>;       
      case "retweet":
        return <RetweetIcon className={this.state.className}/>;       
      case "compose":
        return <EditIcon className={this.state.className}/>;       
      case "close":
        return <CloseIcon className={this.state.className}/>;       
      case "drawer":
        return <DrawerIcon className={this.state.className}/>;       
      case "blog":
        return <BlogIcon className={this.state.className}/>;       
      case "history":
        return <HistoryIcon className={this.state.className}/>;       
      case "settings":
        return <SettingsIcon className={this.state.className}/>;       
      case "debug":
        return <DebugIcon className={this.state.className}/>;       
      case "save":
        return <SaveIcon className={this.state.className}/>;       
      case "menu":
        return <MenuIcon className={this.state.className}/>;       
      case "question":
        return <QuestionIcon className={this.state.className}/>;       
      case "ok":
        return <OKIcon className={this.state.className}/>;       
      default:
        return <NotFoundIcon className={this.state.className}/>;
    }
  }

  render() {
    const ico = this.getIcon(this.props.icon);
    return (
      ico
    )
  }
}

export default withStyles(styles)(UIIcon);



// WEBPACK FOOTER //
// ./src/core/ui/icon.js